// extracted by mini-css-extract-plugin
export default {"th":"Manage_th__7SFrj"};